// removed by extract-text-webpack-plugin
module.exports = {"root":"TransactionPage-module__root__2uc6L","loading":"TransactionPage-module__loading__1gX6P","error":"TransactionPage-module__error__3axu_","tabContent":"TransactionPage-module__tabContent__2CTGD","tabContentVisible":"TransactionPage-module__tabContentVisible__hAnYH","footer":"TransactionPage-module__footer__1M_7n"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TransactionPage/TransactionPage.module.css
// module id = 2477
// module chunks = 0